import React, { useState } from 'react';
import './App.css';

function HtmlViewer() {
  const [htmlCode, setHtmlCode] = useState(`<!-- Escreva ou cole seu código HTML aqui -->
<div style="text-align: center; padding: 20px; font-family: Arial;">
  <h2>Visualizador HTML</h2>
  <p>O resultado do seu código aparecerá aqui!</p>
</div>`);

  return (
    <div style={{ display: 'flex', height: 'calc(100vh - 60px)', background: '#f4f7f6', padding: '20px', boxSizing: 'border-box' }}>
      
      {/* Editor (Lado Esquerdo) */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', marginRight: '20px', background: '#fff', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', overflow: 'hidden' }}>
        <div style={{ background: '#2c3e50', color: '#fff', padding: '12px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ margin: 0, fontSize: '16px' }}>Editor de Código</h3>
          <button 
            onClick={() => setHtmlCode('')}
            style={{ background: '#e74c3c', color: '#fff', border: 'none', padding: '6px 12px', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}
          >
            Limpar
          </button>
        </div>
        <textarea
          value={htmlCode}
          onChange={(e) => setHtmlCode(e.target.value)}
          style={{ 
            flex: 1, 
            width: '100%', 
            padding: '15px', 
            border: 'none', 
            resize: 'none', 
            fontFamily: 'monospace', 
            fontSize: '14px', 
            outline: 'none',
            background: '#1e1e1e',
            color: '#d4d4d4',
            boxSizing: 'border-box'
          }}
          spellCheck="false"
        />
      </div>

      {/* Preview (Lado Direito) */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', background: '#fff', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', overflow: 'hidden' }}>
        <div style={{ background: '#ecf0f1', color: '#2c3e50', padding: '12px 20px', borderBottom: '1px solid #ddd' }}>
          <h3 style={{ margin: 0, fontSize: '16px' }}>Visualização (Preview)</h3>
        </div>
        <iframe
          title="HTML Preview"
          srcDoc={htmlCode}
          style={{ flex: 1, width: '100%', border: 'none', backgroundColor: '#fff' }}
          sandbox="allow-scripts"
        />
      </div>

    </div>
  );
}

export default HtmlViewer;
